import React from "react";
import { Row, Input, Col, Form, Button, Select } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { InputCpf } from "../InputCpf";

import { Wrapper } from "./styles";

const { Option } = Select;

export function Search({ onSearch, onClear }) {
  const [form] = Form.useForm();

  function onReset() {
    onClear();
    form.resetFields();
  }

  function onSubmit(values) {
    onSearch(values);
  }

  return (
    <Wrapper>
      <div className="advance-search">
        <Form
          onFinish={onSubmit}
          layout="vertical"
          form={form}
          name="busca"
          key="busca"
        >
          <Row justify="center">
            <Col span={7}>
              <Form.Item className="inputStyle" name="nome" label="Nome:">
                <Input style={{ borderRadius: 60, height: 32 }} />
              </Form.Item>
            </Col>
            <Col span={7} offset={1}>
              <Form.Item name="cpf" label="CPF:">
                <InputCpf style={{ borderRadius: 60, height: 32 }} />
              </Form.Item>
            </Col>
            <Col span={7} offset={1}>
              <Form.Item name="sistema" label="Sistema:">
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="AGILIS">AGILIS</Option>
                  <Option value="CEREBRUM">CEREBRUM</Option>
                  <Option value="SIP3W">SIP3W</Option>
                  <Option value="CONSULTA_INTEGRADA">CONSULTA INTEGRADA</Option>
                  <Option value="PCA">PCA</Option>
                  <Option value="ROTAS">ROTAS</Option>
                  <Option value="APOLO_PROCUMPRI">APOLO PROCUMPRI</Option>
                  <Option value="APOLO_SAP">APOLO SAP</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end">
            <Col>
              <Button
                onClick={onReset}
                icon={<ClearOutlined />}
                style={{ marginRight: 5 }}
              >
                Limpar
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                style={{ marginRight: 20 }}
                htmlType="submit"
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Wrapper>
  );
}

Search.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};
